import course from '@apps/www/locales/en/course/index.json';
import courseWatch from '@apps/www/locales/en/course/watch/index.json';

export default {
	course,
	course_watch: courseWatch,
};
